require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-warehouse-style-apartments-within-an-original-building.json") })
        }
      }, "path---news-warehouse-style-apartments-within-an-original-building");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-warehouse-style-apartments-within-an-original-building!./.cache/json/news-warehouse-style-apartments-within-an-original-building.json
// module id = 861
// module chunks = 231608221292675